export default "__VITE_ASSET__17yP7N0n__"